/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestsListResponse, RequestBasicInfoResultEntity } from '../model/requestslistresponse';
import { RequestActions } from '../model/requestsactionsresponse';
import { Subject, Observable } from 'rxjs';
import {tap} from 'rxjs/internal/operators';
import { RequestInfo } from '../model/requestinforesponse';
import { RequestAttachment } from '../model/requestattachmentresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { RequestsFilterInfo } from '../model/requestsfilterinfo';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { StatusTypeResultEntity } from '../../shared/model/requeststatustyperesponse';
@Injectable()
export class RequestslistService {
  private selectedRequestBasicInfo = new Subject<RequestBasicInfoResultEntity>();
  private requestInfoSubject = new Subject<RequestInfo>();
  requestsfilterInfo: RequestsFilterInfo = new RequestsFilterInfo();
  private _requestCount = new Subject<number>();

  constructor(public http: HttpClient) {
  }

  // function call to fetch item list
  public getRequestsList(params: HttpParams): Observable<RequestsListResponse> {
    let data = this.http.get<RequestsListResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/requests', { params })
    .pipe(tap(resp => {
      this._requestCount.next(resp.resultCount);
    })
    );
    return data;
  }

  public getRequestsActions(requestId: number) {
    return this.http.get<RequestActions>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/requests/' + requestId + '/requestActions');

  }

  applyAction(selectedAction: RequestBasicInfoResultEntity) {
    this.selectedRequestBasicInfo.next(selectedAction);
  }

  getSelectedAction(): Subject<RequestBasicInfoResultEntity> {
    return this.selectedRequestBasicInfo;
  }

  publishRequestChanges(requestInfoSubject: RequestInfo) {
    this.requestInfoSubject.next(requestInfoSubject);
  }

  getUpdatedRequestChanges(): Subject<RequestInfo> {
    return this.requestInfoSubject;
  }

  public getAttachmentDetails(requestNumber: number) {
    return this.http.get<RequestAttachment>(CommonConstants.SERVICE_VERSION_PATH_V1
      + '/customer/requests/' + requestNumber + '/attachments');
  }


  public getAttachmentDetailsWithNotes(requestNumber: number, noteId: number) {
    return this.http.get<RequestAttachment>(CommonConstants.SERVICE_VERSION_PATH_V1
      + '/customer/requests/' + requestNumber + '/attachments?noteId=' + noteId);
  }

  public getItemCategories() {
    const params = new HttpParams()
      .set('itemOption', 'ALL');
    return this.http.get<ItemCategoriesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/allCategories', { params });
  }

  public getItemTypes() {
    const params = new HttpParams()
      .set('itemOption', 'ALL');
    return this.http.get<ItemTypesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/allItemTypes', { params });
  }

  public getStatusTypes() {
    return this.http.get<StatusTypeResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/requests/allStatusTypes');
  }

  public getRequestCount(): Observable<number> {
    return this._requestCount;
  }
}

